// =============================================
// Helper Text Component
// KipiKid - טקסט עזרה קבוע מתחת לשדות קלט
// =============================================

interface HelperTextProps {
  text: string;
  color?: string;
  fontSize?: string;
}

export default function HelperText({
  text,
  color = '#9ca3af',
  fontSize = '11px',
}: HelperTextProps) {
  return (
    <p
      style={{
        fontSize,
        color,
        marginTop: '4px',
        marginBottom: 0,
        lineHeight: '1.4',
        direction: 'rtl',
      }}
    >
      {text}
    </p>
  );
}
